/* src/app/self-enrollment/verification-valid/verification-valid.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
/*# sourceMappingURL=verification-valid.component.css.map */
